import pdfMake from 'pdfmake/build/pdfmake.js';
import * as htmlToImage from 'html-to-image';
import moment from 'moment';

const ReportTestPdf = async (data) => {

    console.log(data)//border-collapse: collapse;

    const div = document.createElement('div');
    div.innerHTML = data.resultados;

    //const table = document.getElementsByTagName('table');


    const imgBase = htmlToImage.toPng(div, { width: 600, height: 180 })
        .then(function (dataUrl) {

            return dataUrl;
        })
        .catch(function (error) {
            console.error('oops, something went wrong!', error);
        });

    const imgData = await imgBase;

    const div2 = document.createElement('div');
    div2.innerHTML = data.parametros;

    const imgBase2 = htmlToImage.toPng(div2, { width: 600, height: 180 })
        .then(function (dataUrl) {

            return dataUrl;
        })
        .catch(function (error) {
            console.error('oops, something went wrong!', error);
        });

    const imgData2 = await imgBase2;

    const fecha = moment(data.fecha + " " + data.hora).format('lll');


    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        },
        CantoraOne: {
            bold: 'CantoraOne-Regular.ttf'
        }
    };

    const contentPDF = [{
        margin: [0, 160, 0, 0],
        columns: [
            {
                ul: [
                    { text: 'Historia Clinica No. ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                    { text: data.names, bold: true, style: 'textStyle', listType: 'none' },
                    { text: 'No. Documento: ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                    { text: 'Edad: ' + data.age, style: 'textStyle', listType: 'none' },
                    { text: 'Remitido Por: ' + data.remitente, style: 'textStyle', listType: 'none' }
                ]
            },
            {
                ul: [
                    { text: ' ', style: 'textStyle', listType: 'none' },
                    { text: 'Dirección: ' + data.address, style: 'textStyle', listType: 'none' },
                    { text: 'Telefono: ' + data.telephone, style: 'textStyle', listType: 'none' },
                    { text: 'Ocupacion: ' + data.ocupation, style: 'textStyle', listType: 'none' },
                    { text: 'Entidad: ' + data.plan, style: 'textStyle', listType: 'none' },
                ]
            },
        ],
        // optional space between columns
        columnGap: 10
    },
    {
        // auto-sized columns have their widths based on their content                                       
        margin: [0, 5, 0, 0],
        layout: {
            defaultBorder: false,
        },
        table: {
            headerRows: 1,
            widths: [90, '*', 200],
            heights: 20,
            body: [
                [{ text: 'Tipo de Atención ', style: 'textStyle', border: [false, true, false, false] },
                { text: 'Procedimiento', bold: true, style: 'textStyle', border: [false, true, false, false] },
                { text: 'Fecha: ' + fecha, style: 'textStyle', border: [false, true, false, false] }],
                [{ text: 'Firma Digital ', style: 'textStyle', border: [false, true, false, false] },
                { text: 'SANDRA ARDILA', bold: true, style: 'textStyle', border: [false, true, false, false] },
                { text: '', style: 'textStyle', border: [false, true, false, false] }],
            ]
        },
    }];

    if (data.motivo_consulta != undefined && data.motivo_consulta != null && data.motivo_consulta != "") {
        contentPDF.push({ style: 'textStyle', margin: [0, 5, 0, 2], text: [{ text: 'MOTIVO DE CONSULTA: ', bold: true }, data.motivo_consulta] });
    }

    if (data.procedimiento != undefined && data.procedimiento != null && data.procedimiento != "") {
        contentPDF.push({ style: 'textStyle', margin: [0, 5, 0, 2], text: [{ text: 'PROCEDIMIENTO: ', bold: true }, data.procedimiento] });
    }

    //PARAMETROS DE ESTIMULACIÓN
    contentPDF.push({
        style: 'textStyle', margin: [0, 5, 0, 2], text: [{ text: 'PARAMETROS DE ESTIMULACION PARA EL REGISTRO:', bold: true }]
    });
    contentPDF.push({
        // you can also fit the image inside a rectangle
        image: imgData2,
        fit: [350, 150],
        alignment: 'center',
    });

    //RESULTADOS
    contentPDF.push({
        style: 'textStyle', margin: [0, 5, 0, 2], text: [{ text: 'RESULTADOS: ', bold: true }]
    });
    contentPDF.push( {
        // you can also fit the image inside a rectangle
        image: imgData,
        fit: [350, 150],
        alignment: 'center',
    });

    if (data.interpretacion != undefined && data.interpretacion != null && data.interpretacion != "") {
        contentPDF.push({ style: 'textStyle', margin: [0, 5, 0, 2], text: [{ text: 'INTERPRETACION: ', bold: true }, data.interpretacion] });
    }

    if (data.observaciones != undefined && data.observaciones != null && data.observaciones != "") {
        contentPDF.push({ style: 'textStyle', margin: [0, 5, 0, 2], text: [{ text: 'OBSERVACION: ', bold: true }, data.observaciones] });
    }
    
    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        info: {
            author: "",
        },
        content: contentPDF,
        styles: {
            textStyle: {
                fontSize: 10,
                font: 'OpenSans'
            },
            textStylePac: {
                fontSize: 10,
                font: 'OpenSans',
                bold: true
            },
            tableheader: {
                fontSize: 11,
                bold: true,
                font: 'OpenSans',
                margin: [0, 20]
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left',
                font: 'OpenSans'
            },
        }
    }

    pdfMake.createPdf(documentDefinition).open();

}

export default ReportTestPdf